import React, { useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
import useStateRef from "react-usestateref";
import "./index.css";
import "./loginascustomer.css";
import { TextboxCustom } from "src/components/TextboxCustom";
import { FormControl, Spinner } from "native-base";
import EventEmitter from "src/utils/EventEmitter";
import axios from "axios";
import { useSnackbar } from "notistack";
import { CloseSnackbarAction } from "src/components/CloseSnackbarAction";
import CancelIcon from "@mui/icons-material/Cancel";
import qs from "qs";
import { useAxiosInstance } from 'src/utils/useAxiosInstance';

const LoginAsCustomerView = (props) => {
  /* eslint-disable */
  const { enqueueSnackbar } = useSnackbar();

  const [error, setError, errorRef] = useStateRef({
    email: false,
    emailFormat: false,
    loginCustomer: false,
  });
  const [email, setEmail, emailRef] = useStateRef(null);
  const [loading, setLoading, loadingRef] = useStateRef(false);
  const [firstName, setFirstName, firstNameRef] = useStateRef("");
  const { axiosInstance } = useAxiosInstance();

  useEffect(() => {
    const onClickPrevStep = () => {
      onPrevStep();
    };

    const listener = EventEmitter.addListener(
      "prev_step_login_as_customer",
      onClickPrevStep
    );

    return () => {
      listener.remove();
    };
  }, []);

  useEffect(() => {
    let user_data = null;

    if (user_data) {
      if (user_data.Name) {
        var name = user_data.Name.split(" ")[0];
        setFirstName(name);
      }
    }
  }, []);
  // const onNavigate = (url) => {
  //   navigate(url)
  // }

  /* eslint-enable */

  const onPrevStep = () => {
    EventEmitter.emit("show_login_as_customer", { value: false });
    EventEmitter.emit("check_location", { value: window.location.pathname });
  };

  const onChange = (e) => {
    setEmail(e);
    if (e) {
      setError({
        ...errorRef.current,
        emailFormat: false,
        email: false,
        loginCustomer: false,
      });
    } else {
      setError({
        ...errorRef.current,
        emailFormat: false,
        loginCustomer: false,
      });
    }
  };

  const clearScript = (e) => {
    setEmail("");
    setError({ ...errorRef.current, emailFormat: false, loginCustomer: false });
  };

  const checkFormat = () => {
    if (emailRef.current) {
      var mailformat =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      if (!emailRef.current.match(mailformat)) {
        setError({
          ...errorRef.current,
          emailFormat: true,
          email: false,
          loginCustomer: false,
        });
      } else {
        setError({
          ...errorRef.current,
          emailFormat: false,
          email: false,
          loginCustomer: false,
        });
      }
    } else {
      setError({
        ...errorRef.current,
        emailFormat: false,
        loginCustomer: false,
      });
    }
  };

  const onSubmit = async () => {
    if (emailRef.current && !errorRef.current.emailFormat) {
      setLoading(true);

      try {
        await axiosInstance
          .post(
            `/login-consignment-customer`, {
              Email: emailRef.current,
            }
          )
          .then(async (response) => {
            enqueueSnackbar(
              `You have successfully logged in as ${emailRef.current}`,
              {
                variant: 'success'
              }
            );
            localStorage.setItem("impersonate-token", response.data.data.token);

            setTimeout(() => {
              window.location.href = '/';
            }, 2000);
          });
      } catch (e) {
        setError({ ...errorRef.current, loginCustomer: true });
        setLoading(false);
      }
      setLoading(false);
    } else {
      setError({ ...errorRef.current, email: true });
    }
  };

  const onFormEnter = (e) => {
    checkFormat();
    if (e.key === "Enter") {
      onSubmit();
    }
  };

  return (
    <div className="main-wrapper">
      <div className="kyc-wrapper-container kyc-wrapper-container-custom">
        <div
          className="identity-container"
          style={{ height: "100%", marginTop: "0px" }}
        >
          <div
            className="identity-container-wrapper space-between upload-script"
            style={{ height: "100%" }}
          >
            <div className="top-wrapper">
              <div className="kyc-title kyc-title-40">Login as Customer</div>
              <div style={{ marginTop: "45px" }}>
                <FormControl
                  isInvalid={
                    errorRef.current.email ||
                    errorRef.current.emailFormat ||
                    errorRef.current.loginCustomer
                      ? true
                      : false
                  }
                  w="100%"
                  maxW="100%"
                >
                  <FormControl.Label
                    style={{ marginBottom: "8px", marginTop: "0px" }}
                  >
                    <div className="login-textbox-title">
                      Enter customer email
                    </div>
                  </FormControl.Label>
                  <TextboxCustom
                    name="escript_url"
                    placeholder="Enter customer email"
                    onChangeText={(e) => onChange(e)}
                    onBlur={() => checkFormat()}
                    onKeyPress={(e) => onFormEnter(e)}
                    backgroundColor={
                      errorRef.current.email ||
                      errorRef.current.emailFormat ||
                      errorRef.current.loginCustomer
                        ? "custom.red.2"
                        : "white"
                    }
                    value={emailRef.current ? emailRef.current : ""}
                    InputRightElement={
                      emailRef.current ? (
                        <div
                          style={{
                            paddingRight: "10px",
                            display: "flex",
                            cursor: "pointer",
                          }}
                        >
                          <CancelIcon
                            style={{ width: "20px" }}
                            onClick={() => clearScript()}
                          />
                        </div>
                      ) : (
                        ""
                      )
                    }
                  />
                </FormControl>
              </div>
              {errorRef.current.email ||
              errorRef.current.emailFormat ||
              errorRef.current.loginCustomer ? (
                <span className="error-message">
                  {errorRef.current.emailFormat
                    ? "Please enter the correct email format"
                    : errorRef.current.loginCustomer
                    ? "You don't have access to this customer."
                    : "Email is required"}
                </span>
              ) : (
                ""
              )}
            </div>
            <div className="bottom-wrapper">
              <div className="bottom-wrapper-button hide-desktop">
                <div className="center_container button_wrapper">
                  <button
                    className="custom-button-green column"
                    onClick={() => onSubmit()}
                  >
                    {loadingRef.current ? (
                      <Spinner color="white" style={{ marginRight: "8px" }} />
                    ) : (
                      ""
                    )}{" "}
                    Submit
                  </button>
                </div>
                <div className="center_container button_wrapper">
                  <button
                    className="custom-button-white column"
                    onClick={() => onPrevStep()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
              <div className="bottom-wrapper-button hide-mobile">
                <div className="center_container button_wrapper">
                  <button
                    className="custom-button-white column"
                    onClick={() => onPrevStep()}
                  >
                    Cancel
                  </button>
                </div>
                <div className="center_container button_wrapper">
                  <button
                    className="custom-button-green column"
                    onClick={() => onSubmit()}
                  >
                    {loadingRef.current ? (
                      <Spinner color="white" style={{ marginRight: "8px" }} />
                    ) : (
                      ""
                    )}{" "}
                    Submit
                  </button>
                </div>
              </div>
              <div className="hide-desktop" style={{ height: "23px" }}></div>
              <div className="hide-mobile" style={{ height: "38px" }}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginAsCustomerView;
